import React, { Component, Fragment } from "react"
import actions from "./actions/root_action"
import { connect } from "react-redux"
import { withNamespaces } from "react-i18next"
import { compose } from "redux"
import Modal from '../../../common/components/modal_dialog/modal_wrapper_component'
import "./main_container.scss"
import lozad from 'lozad'

const imgdir = '/assets/image/campaigns/rebrand_oyado'

export class Main extends Component {
  async componentDidMount() {
    const observer = lozad()
    observer.observe()
  }

  render() {
    return (
      <React.Fragment>
        <div styleName="container">
          <h1>
            <img className="lozad" data-src={`${imgdir}/eyecatch-pc.png`} styleName="eye-catch" alt=""/>
            <img className="lozad" data-src={`${imgdir}/eyecatch-sp.png`} styleName="eye-catch sp-only" alt=""/>
          </h1>
          <div styleName="cpn-term">
            <div>
              <span>エントリー受付・予約対象期間: </span>
              <span>2024年12月3日(火)12:00 ～ 12月17日(火)11:59</span>
            </div>
            <div>
              <span>宿泊対象期間： </span>
              <span>2024年12月3日(火)チェックイン 〜 2025年3月31日(月)チェックアウト</span>
            </div>
          </div>
          <div styleName="block cpn-note">
            <h2>キャンペーン概要</h2>
            <p>上記対象期間中に当該キャンペーンのログインフォームよりご応募(エントリー)いただき、Rakuten Oyadoにて宿泊施設をご予約し､楽天IDにて決済し、実際にご宿泊された方に楽天ポイントを通常ポイント(1倍)に加えて、楽天ポイントを5倍還元（通常ポイント1倍に加えて＋特典ポイント4倍）</p>
          </div>
          <div styleName="block">
            <div styleName="info">
              本キャンペーンは終了しました。
            </div>
          </div>
          <section>
            <h2 styleName="section-header">キャンペーン参加方法</h2>
            <div styleName="block text-center">
              <div styleName="steps">
                <img className="lozad" data-src={`${imgdir}/step1.png`} />
                <img className="lozad" data-src={`${imgdir}/step2.png`} />
              </div>
              <div>進呈するポイント（期間限定ポイント含）には上限や条件があります。詳細は<a href="#cpn-details">こちら</a></div>
              <img styleName="insentive" className="lozad" data-src={`${imgdir}/insentive.png`} />
              <div>※予約後のエントリーは対象外となります。あらかじめご了承ください。</div>
            </div>
            {/* <div styleName="block">
              <a href="https://oubo.rakuten.co.jp/apply/rs/oyado2412" target="_blank" id="entry-button-1" styleName="entry-button">エントリーはこちら</a>
              <div styleName="entry-button-caption">エントリーには楽天IDログインが必要です。</div>
              <a href="/search" id="properties-button-1" styleName="property-button">空室検索はこちら</a>
            </div> */}
          </section>
          <section id="cpn-details" styleName="cpn-details">
            <h2 styleName="section-header">キャンペーン詳細</h2>
            <div styleName="block">
              <h3>キャンペーン内容</h3>
              <p>下記対象期間中に当該キャンペーンのログインフォームよりご応募(エントリー)いただき、Rakuten Oyadoにて宿泊施設をご予約し､楽天IDにて決済し、実際にご宿泊された方に楽天ポイントを通常ポイント(1％)に加えて、下記のとおり還元いたします｡（エントリーした際の楽天IDを用いたご予約に限ります）<br/>
              ・宿泊・・・楽天ポイントを5倍（通常ポイント1倍に加えて＋特典ポイント4倍）</p>

              <h3>キャンペーン対象者</h3>
              <p>下記対象期間中に当該キャンペーンのログインフォームよりご応募(エントリー)いただき、Rakuten Oyadoにて宿泊施設を予約し､楽天IDにて決済し、実際にご宿泊された楽天会員様</p>

              <h3>対象施設</h3>
              <p>
                Rakuten Oyado 掲載の全施設<br/>
                {/* <a href="/campaigns/vissel-kobe-2023/properties">対象施設はこちら</a> */}
              </p>

              <h3>エントリー受付期間</h3>
              <p>2024年12月3日(火)12:00 ～12月17日(火)11:59</p>
              <div styleName="note">
                ※本キャンペーンはエントリー制です。キャンペーンに参加するにはエントリーが必要です。
              </div>

              <h3>予約期間</h3>
              <p>2024年12月3日(火)12:00 ～12月17日(火)11:59</p>
              <div styleName="note">
                ※予約後のエントリーは対象外となります。あらかじめご了承ください。
              </div>

              <h3>宿泊期間</h3>
              <p>2024年12月3日(火)チェックイン 〜 2025年3月31日(月)チェックアウト</p>

              <h3>特典ポイント</h3>
              <p>楽天ポイントを5倍（通常ポイント1倍に加えて＋特典ポイント4倍）</p>
              <div styleName="note">
                ※特典ポイントの利用期限は2025年6月30日（月）23:59までとなります。<br/>
                ※特典ポイントは、予約番号1件ごとに還元いたします。<br/>
                ※特典ポイントは、クーポン利用の場合はクーポン割引「後」の金額、ポイント利用の場合はポイント利用「前」の金額を元に計算されます。<br/>
                ※特典ポイントは、Rakuten Oyadoサイト上で成立している料金(税抜)をもとに計算いたします。詳細は<a href="https://vs-guest.zendesk.com/hc/ja/articles/10777768202255-%E6%A5%BD%E5%A4%A9%E3%83%9D%E3%82%A4%E3%83%B3%E3%83%88%E3%81%AE%E4%BB%98%E4%B8%8E%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6" target="_blank">こちら</a>をご確認ください。<br/>
                ※予約者と利用者が異なっても対象となります。 楽天ポイントは予約者の会員IDに還元されます。<br/>
                ※ポイント還元時点でキャンセルとなっているご予約は対象外となります。
              </div>

              <h3>特典ポイント還元時期</h3>
              <p>
                当該キャンペーンの特典ポイントは、通常サービス利用で還元されるポイントとは別に2025年4月末までに還元いたします。キャンペーン終了後、特典ポイント還元まで期間がありますのでご注意ください。
              </p>
              <div styleName="note">
                ※獲得したポイントは、楽天ポイント履歴画面でご確認ください。<br/>
                ※1ヶ月でご利用いただけるポイントは、「ポイント利用可能サービス」での利用額を合算して10万ポイントが上限(ダイヤモンドランクの会員様は50万ポイントまで)です。上限を超えるポイントを獲得された場合、ポイントがご利用いただけないまま失効する事がございますので、あらかじめご了承ください。<br/>
                期間限定ポイントについては<a href="https://point.rakuten.co.jp/guidance/terms/" target="_blank">こちら</a>をご参照ください。
              </div>

              <h3>特典ポイントの上限</h3>
              <p>
                本キャンペーンにおける、1会員様あたりのキャンペーン還元ポイント上限は「10,000ポイント」になります。また、1ヶ月でご利用いただけるポイントは10万ポイントが上限ですので（ダイヤモンドランクの会員様は50万ポイントまで）、それを超えるポイントを獲得された場合、ポイントがご利用いただけないまま失効する事がございますので、あらかじめご了承ください。
              </p>

              <h3>注意事項</h3>
              <ul>
                <li>ご予約後、キャンセルまたは連絡なき不泊(NO-SHOW)、期間対象外となる予約変更は対象となりません。また、期間対象外となるご予約が成立し、その後インターネットを経由しない変更(現地施設でのお申し出など)で、期間内に該当するご予約になった場合も当該キャンペーンの対象とはなりません。</li>
                <li>宿泊期間対象外となるご予約が成立した後、対象期間内に予約変更（日程短縮等）をサイト上から実施してもシステム上、当該キャンペーンの対象外となります。</li>
                <li>アクセス集中やメンテナンスなどによりキャンペーン対象期間中のご利用ができなかった場合、キャンペーン対象外となります。</li>
                <li>本キャンペーンの対象予約が､別途エントリーいただいているRakuten Oyado主催の他キャンペーンにおいてもキャンペーン還元ポイントの対象となる場合は､いずれかのキャンペーンを優先し､優先されたキャンペーン還元ポイントのみを還元させていただく場合がございますので予めご了承ください｡</li>
                <li>キャンペーン内容は予告なく変更・終了することがあります。予めご了承ください。</li>
              </ul>
            </div>
            {/* <div styleName="block">
              <a href="https://oubo.rakuten.co.jp/apply/rs/oyado2412" target="_blank" id="entry-button-2" styleName="entry-button">エントリーはこちら</a>
              <div styleName="entry-button-caption">エントリーには楽天IDログインが必要です。</div>
              <a href="/search" id="properties-button-2" styleName="property-button">空室検索はこちら</a>
            </div> */}
          </section>
        </div>
        <Modal />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    login: state.login,
    language: state.language,
    modal: state.modal
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: actions(dispatch)
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNamespaces()
)(Main)
